import Vue from 'vue'
import Router from 'vue-router'
import login from '@/views/login'
import home from '@/views/home'
import Users from '@/views/users'
import notFound from '@/views/notFound'
import assets from '@/views/assets'
import Dashboard from '@/views/Dashboard'
import jwtDecode from 'jwt-decode'


Vue.use(Router);

const router = new Router({
  mode: 'history',
  routes: [{
      path: '/',
      name: 'login',
      component: login
    },
    {
      path: '*',
      redirect: {
        name: 'notFound'
      }
    },
    {
      path: '/home',
      name: 'home',
      component: home,
      meta: {
        requiresAuth: true,
        roles: ['management', 'user', 'dashboard', 'AIS_Dashboard']
      }
    },
    {
      path: '/users',
      name: 'users',
      component: Users,
      meta: {
        requiresAuth: true,
        roles: ['management', 'user', 'dashboard', 'AIS_Dashboard']
      }
    },
    {
      path: '/notFound',
      name: 'notFound',
      component: notFound
    },
    {
      path: '/assets',
      name: 'assets',
      component: assets,
      meta: {
        requiresAuth: true,
        roles: ['management', 'user', 'dashboard', 'AIS_Dashboard']
      }
    },
    {
      path: '/Dashboard',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true,
        roles: ['management', 'user', 'dashboard', 'AIS_Dashboard']
      }
    },
  ]
});

router.beforeEach((to, from, next) => {
  if (to.meta.requiresAuth) {
    if (!sessionStorage.getItem('user-token')) {
      next({
        name: 'login'
      })
    } else {
      let decoded = jwtDecode(sessionStorage.getItem('user-token')).role
      for (let x in to.meta.roles) {
        if (decoded === to.meta.roles[x]) {
          next()
        }
      }
    }
  } else {
    next()
  }
})

export default router;